import styled from 'styled-components';

export const MarginTop = styled.div`
margin-top: 50px;

`;
export const Element = styled.div`
width: 100%;
display: flex;
flex-direction: column;
flex-wrap: nowrap;
overflow: hidden;
`;
export const TextElement = styled.div`
margin-top: 20px;
width: 100%;
display: flex;
flex-direction: column;
flex-wrap: wrap;
overflow: hidden;
margin-bottom: 0;
`;
export const Inline = styled.div` 
display: inline; 
`;
export const Section = styled.div`
width: 70%;
margin-left: 15%;
@media only screen and (max-width: 850px) {
    width: 95%;
    margin-left: 2.5%;
    /* text-align: left; */
}
@media only screen and (max-width: 520px) {
    display: block;
    text-align: center;
}
`;
export const Text = styled.p`
font-family: Ubuntu;
font-size: 14px; 
color: gray;
display: block; 
/* display: flex; */
flex-direction: row;
float: ${ props => { switch (props.align) { case 'left': { return 'left'; } case 'right': { return 'right'; } default: { return 'left'; } } }};
:hover{
    color: orange;
    cursor: pointer;
}
@media only screen and (max-width: 520px) {
    font-size: 14px;
    float: left;
    display: inline-block;
    width: 100%;
}
`;

export const Container = styled.div`
display: flex;
flex-direction: column;
align-self: center;
width: 640px;
@media only screen and (max-width: 850px) {
    width: 400px;
    /* text-align: left; */
}
@media only screen and (max-width: 510px) {
    width: 350px;
}
@media only screen and (max-width: 400px) {
    width: 275px;
}

`;
export const FacebookIcon = styled.img`
display: flex;
flex-direction: row;
align-self: center;
:hover{
    cursor: pointer;
}
`;
export const Break = styled.div`
  flex-basis: 100%;
  height: 0;
`;